export * from "./PeopleIconTooltip";
export * from "./StarIconTooltip";
